<template>
  <v-container>
    <v-text-field label="Description" placeholder="Hidden from students" v-model="question.description"></v-text-field>
    <v-card>

      <v-tabs v-model="tab" background-color="red lighten-2" dark>
        <v-tab v-for="n in length" :key="n">
          Version {{ n }}
        </v-tab>

      </v-tabs>

      <v-card-text class="text-center">
        <!-- <v-btn text @click="length--">Remove Tab</v-btn> -->
        <v-row>
          <!-- <v-btn color="primary" text disabled>Total Mark for this Question: {{ totalScore() }}</v-btn>
          <v-divider class="mx-4" vertical></v-divider>  -->
          <v-btn color="primary" @click="addNewVersion()">Add Version</v-btn>

          <!-- <v-spacer></v-spacer> -->

          <!-- </v-col> -->
        </v-row>

      </v-card-text>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="version in question.versions" :key="version.id">

          <v-container v-if="question.type == 'Multiple Choices'">
            <v-row>
              <v-col cols="10">
                <v-textarea outlined name="input-7-4" label="Question" value type="number" v-model="version.text">
                </v-textarea>

                <div>
                  <v-text-field label="Choice A" placeholder="Placeholder" v-model="version.optionA"></v-text-field>
                  <v-text-field label="Choice B" placeholder="Placeholder" v-model="version.optionB"></v-text-field>
                  <v-text-field label="Choice C" placeholder="Placeholder" v-model="version.optionC"></v-text-field>
                  <v-text-field label="Choice D" placeholder="Placeholder" v-model="version.optionD"></v-text-field>
                </div>
              </v-col>

              <v-col cols="2">
                <v-row>
                  <v-switch v-model="version.hasTextfield" class="ma-2" label="Textfield?"></v-switch>
                </v-row>
                <v-file-input accept="image/*" label="Upload image" @change="onUpload(version, -1)"
                  v-model="version.fileUploadSlot"></v-file-input>

                <v-img v-if="version.image" v-bind:src="'/question/getImage/' + version.image">
                </v-img>
              </v-col>

            </v-row>
          </v-container>

          <v-container v-else>

            <v-card-text class="text-center">

              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel v-for="(item,i) in version.parts.length" :key="i">
                  <v-expansion-panel-header>Part {{ item }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="10">

                        <v-textarea outlined name="input-7-4" label="Question" value type="number"
                          v-model="version.parts[i].text"></v-textarea>

                      </v-col>

                      <v-col cols="2">
                        <v-text-field label="Part Mark" placeholder="0" v-model="version.parts[i].partScore">
                        </v-text-field>

                        <v-row>
                          <v-switch v-model="version.parts[i].demandUpload" class="ma-2" label="Upload pic?"></v-switch>
                        </v-row>

                        <v-row>
                          <v-icon v-if="i != 0" v-on:click="up(version, i)">mdi-arrow-up-drop-circle</v-icon>

                          <v-icon v-if="i != version.parts.length - 1" v-on:click="down(version, i)">
                            mdi-arrow-down-drop-circle</v-icon>
                          <v-icon v-on:click="deleteThisPart(version, i)">mdi-delete</v-icon>

                          <v-file-input accept="image/*" label="Upload image" @change="onUpload(version, i)"
                            v-model="version.parts[i].fileUploadSlot"></v-file-input>

                          <v-img v-if="version.parts[i].image" v-bind:src="'/question/getImage/' + version.parts[i].image">
                          </v-img>
                        </v-row>

                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>

            </v-card-text>
            <v-btn color="error" v-on:click="deleteThisVersion(version)">Delete this version</v-btn>
            <v-divider class="mx-4" vertical></v-divider>
            <v-btn color="success" dark v-on:click="newPart(version)">New part for this version</v-btn>

            <!-- <v-col cols="4"> -->

          </v-container>

        </v-tab-item>
      </v-tabs-items>

      <!-- <v-spacer></v-spacer> -->

    </v-card>
    <v-row>
      <!-- <v-col cols="4"> -->
      <div class="text-center">
        <v-divider class="mx-4" vertical></v-divider>
        <v-btn color="error" v-on:click="deleteQuestion()">Delete this question</v-btn>
        <v-divider class="mx-4" vertical></v-divider>
        <v-btn color="success" v-on:click="saveQuestion()">Save this question</v-btn>

      </div>

    </v-row>

  </v-container>
</template>

<script>
  export default {
    name: "EditQuestion",
    props: ["id"],

    data: () => ({
      panel: [],
      length: 1,

      tab: null,
      files: [],

      question: {
        description: "",
        score: 0,
        versions: [{ parts: [] }],
      }
    }),

    methods: {
      // Create an array the length of our items
      // with all values as true
      all() {
        this.panel = [...Array(100).keys()].map((k, i) => i);
      },
      // Reset the panel
      none() {
        this.panel = [];
      },
      deleteThisPart(version, i) {
        // console.log("here");
        // alert(JSON.stringify(this.questions));
        version.parts.splice(i, 1);
        //   this.items--;
      },
      newPart(version) {
        version.parts.push({});
      },
      totalScore() {
        var totalScore = 0;

        for (var i = 0; i < this.items; i++) {
          totalScore += Number(this.questions[i].score);
        }

        return totalScore;
      },
      up(version, i) {
        [version.parts[i], version.parts[i - 1]] = [
          version.parts[i - 1],
          version.parts[i]
        ];
        this.all();
      },
      down(version, i) {
        [version.parts[i], version.parts[i + 1]] = [
          version.parts[i + 1],
          version.parts[i]
        ];
        this.all();
      },
      async saveQuestion() {
        var response = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/question",
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify(this.question)
          }
        );

        if (response.ok) {
          var data = await response.json();
          // console.log(data);

          this.question = data;
          alert("saved!");
          // var html = await response.json();
          // alert(html);
        } else {
          alert(response.status + ": " + response.statusText);
        }
      },
      deleteThisVersion(version) {

        let index = this.question.versions.indexOf(version);

        // alert(index);

        if (index !== -1) {
          this.question.versions.splice(index, 1);
          this.length--;
        }

        // alert(this.question.versions.length);

      },
      async deleteQuestion() {
        if (!this.question.id) {
          return window.history.back();
        }

        var response = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/question/" + this.question.id,
          {
            method: "DELETE",
            credentials: "include",
            // headers: {
            //   "Content-Type": "application/json"
            //   // 'Content-Type': 'application/x-www-form-urlencoded',
            // },
            // body: JSON.stringify(this.question)
          }
        );

        if (response.ok) {
          var data = await response.json();
          console.log(data);
          // alert(data);

          window.history.back();

        } else {
          alert(response.status + ": " + response.statusText);
        }
      },
      addNewVersion() {

        this.tab = this.length;
        this.length++;
        // this.tab = val - 1;
        this.question.versions.push({ parts: [{}] });

      },
      async onUpload(version, i) {

        // alert("here");

        let index = this.question.versions.indexOf(version);

        if (!this.question.versions[index].parts[i].fileUploadSlot) {
          this.question.versions[index].parts[i].image = "";
          return;
        }

        // alert("there");

        console.log(" \n\n~~~vi~~~\n\n ");
        console.log(i);
        // console.log(this.files);

        var formData = new FormData()

        if (this.files) {

          console.log("here");

          // formData.append("index", 3);

          formData.append("index", index);

          if (i != -1) {
            formData.append("i", i);
            formData.append("image", this.question.versions[index].parts[i].fileUploadSlot);
          } else {
            formData.append("i", -1);
            formData.append("image", this.question.versions[index].fileUploadSlot)
          }


          var response = await fetch(
            process.env.VUE_APP_API_BASE_URL + "/question/uploadFile/" + this.id,
            {
              method: "PUT",
              credentials: "include",
              headers: {
                // "Content-Type": "application/json"
                // 'Content-Type': 'application/x-www-form-urlencoded',
                // 'Content-Type': 'multipart/form-data'
                'Accept': 'application/json',
              },
              // body: JSON.stringify(this.question)
              body: formData
            });

          if (response.ok) {
            var data = await response.json();
            console.log(data);

            var splits = data[0].fd.split("/");

            var splits2 = splits[splits.length - 1].split(".");

            if (i != -1) {
              this.question.versions[index].parts[i].image = splits2[0] + "?type=" + splits2[1];

              // alert(this.question.versions[index].parts[i].image);
            } else {
              this.question.versions[index].image = splits2[0] + "?type=" + splits2[1];

              // alert(this.question.versions[index].image);
            }

          } else {
            alert(response.status + ": " + response.statusText);
          }


        }
      },
    },

    async mounted() {

      if (this.id) {

        var response = await fetch(
          process.env.VUE_APP_API_BASE_URL + "/question/" + this.id,
          {
            method: "GET",
            credentials: "include",
            // headers: {
            //   "Content-Type": "application/json"
            //   // 'Content-Type': 'application/x-www-form-urlencoded',
            // },
            // body: JSON.stringify(this.question)
          }
        );

        if (response.ok) {
          var data = await response.json();
          console.log(data);

          this.question = data;
          if (!this.question.versions) this.question.versions = [{ parts: [{}] }];

          // alert(JSON.stringify(data));

          this.length = this.question.versions.length;
          // alert(this.length);
          this.all();

        } else {
          alert(response.status + ": " + response.statusText);
        }

      }


    },

    // watch: {
    //   length(val) {
    //     this.tab = val - 1
    //     this.question.versions.push({});
    //   },
    // },
  };
</script>